import { useApolloClient, useQuery } from '@apollo/client';
import { EledoPlanState, EledoPlanStateData, EledoPlanStateVars, GET_CURRENT_PLAN } from 'graphql/EledoPlanState'
import { useEffect, useState } from 'react'

const useCurrentPlan = () => {
  const client = useApolloClient();
  
  const [ currentPlan, setCurrentPlan] = useState<EledoPlanState>();

  const { loading, error, data } = useQuery<EledoPlanStateData, EledoPlanStateVars>(GET_CURRENT_PLAN);
  
  useEffect(() => {
    if (loading || !data){
      return
    }

    const currentPlan: EledoPlanState = structuredClone(data.currentPlan)

    setCurrentPlan(currentPlan)
  }, [data, client, loading])
  
  return { loading, error, currentPlan }
}

export default useCurrentPlan